/*!

=========================================================
* Black Dashboard React v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// react plugin used to create charts
import { Line, Bar } from "react-chartjs-2";
import { NavLink, Link, useLocation } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import moment from "moment";
import ContentEditable from "react-contenteditable";
import NotificationAlert from "react-notification-alert";
import ReactTagInput from "@pathofdev/react-tag-input";
import Autosuggest from "react-autosuggest";
import TagsInput from "react-tagsinput";
// TODO: Replace with MUI Autocomplete - temporarily disabled for React 18 upgrade
// import ChipInput from "material-ui-chip-input";

// TODO CLEANUP: Remove unused makeStyles import - causes runtime errors (ZAI-68)
// makeStyles from @mui/styles requires StyledEngineProvider wrapper for MUI v5
// This import is never used in Feedback component but causes mergeClasses.js:37 TypeError
// See: https://tadepalli.atlassian.net/browse/ZAI-68
// import makeStyles from '@mui/styles/makeStyles';

import Chip from "@mui/material/Chip";
import Autocomplete from '@mui/material/Autocomplete';
import TextField from "@mui/material/TextField";

import { Badge, CardText } from "reactstrap";
import { renderChip, notify } from "./Utils";

// reactstrap components
import {
  Button,
  ButtonGroup,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  Label,
  FormGroup,
  Input,
  Table,
  Row,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  UncontrolledTooltip,
  Form,
  FormText,
} from "reactstrap";

// core components
import { connect } from "react-redux";

function Feedback(props) {

  const ButtonMailto = ({ mailto, label }) => {
    return (
      <Link
        to='#'
        onClick={(e) => {
            window.location = mailto;
            e.preventDefault();
        }}
      >
        {label}
      </Link>
    );
};

  return (
    <>
      <div className="content">
        <Row>
          <Col md="12">
            <Card className="card-tasks" style={{ height: "100%" }}>
              <CardHeader>
                <h2 className="title d-inline">Feedback</h2>
              </CardHeader>
              <CardBody>
                <CardText>
                  If you have any feedback or questions, please email 
                  <ButtonMailto label=" info@zeroui.com" mailto="mailto:info@zeroui.com" />.
                </CardText>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps)(Feedback);
